import { Trans, useTranslation } from 'react-i18next'

import Conversation from '@/components/Chat/Conversation'
import Message from '@/components/Chat/Message'
import { useAppState } from '@/composables/useAppState'
import { useTransComponents } from '@/composables/useTransComponents'

export type QuestionsFeedbackProps = {
  className?: string
  question: string
  appearProfile?: boolean
}

export default function QuestionsFeedback({ className, question, appearProfile }: QuestionsFeedbackProps) {
  const { persona } = useAppState()
  const { components } = useTransComponents()

  const { t } = useTranslation()

  return (
    <Conversation
      persona={persona}
      className={`QuestionsFeedback max-md:pt-[140px] max-md:pb-[80vw] relative z-2 ${className ? className : ''}`}
      appearProfile={appearProfile}
      ariaHeading={t('questions.aria.feedback.heading')}
    >
      <>
        <Message className='mb-8 ml-48 md:ml-56 md:mr-32 col-start-1 md:col-start-1 col-span-10 md:col-span-6'>
          <Trans i18nKey={question} components={components} />
        </Message>
      </>
    </Conversation>
  )
}
